/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S6_Li1Inputs */

const en_guide_what_is_json_s6_li1 = /** @type {(inputs: Guide_What_Is_Json_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Always use <strong>double quotes</strong> for keys and string values: single quotes are not valid JSON`)
};

const ko_guide_what_is_json_s6_li1 = /** @type {(inputs: Guide_What_Is_Json_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`키와 문자열 값에는 항상 <strong>큰따옴표</strong>를 사용하세요: 작은따옴표는 유효한 JSON이 아닙니다`)
};

const ja_guide_what_is_json_s6_li1 = /** @type {(inputs: Guide_What_Is_Json_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーと文字列値には常に<strong>ダブルクォート</strong>を使用してください: シングルクォートはJSONでは無効です`)
};

/**
* | output |
* | --- |
* | "Always use <strong>double quotes</strong> for keys and string values: single quotes are not valid JSON" |
*
* @param {Guide_What_Is_Json_S6_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s6_li1 = /** @type {((inputs?: Guide_What_Is_Json_S6_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S6_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s6_li1(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s6_li1(inputs)
	return ja_guide_what_is_json_s6_li1(inputs)
});